import { Input } from 'ui'
import { usePendingInvitesContext } from '../context/PendingInvitesProvider'

export const Filter = () => {
  const {
    state: { searchTerm },
    actions: { setSearchTerm },
  } = usePendingInvitesContext()

  return (
    <Input
      placeholder="Search by email"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
  )
}
